import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAccountFollowListData } from '@core/Areas/BetLoop/hooks/useAccountFollowListData'
import { EmptyMessage } from '@core/Areas/BetLoop/Components/Common/EmptyMessage'
import { betLoopPrincipleProfileQuery } from '@core/Areas/BetLoop/helpers/queries'
import type { FollowListTabNav } from '@core/Areas/BetLoop/types'
import { ProfilesList } from '@core/Areas/BetLoop/Components/Common/ProfilesList'

export const FollowList: React.FC<{
  currentList: FollowListTabNav
  profileId: string | undefined
}> = ({ currentList, profileId }) => {
  const { data: profile } = useQuery(betLoopPrincipleProfileQuery)

  const isMyProfile = profile?.id === profileId

  const { isLoading, isEmptyState, data, LoadMoreButton } = useAccountFollowListData(
    currentList,
    profileId
  )

  if (isEmptyState) {
    if (isMyProfile) {
      return currentList === 'followers' ? (
        <EmptyMessage
          title='Share your punting powers'
          description={`Share your bets and watch\n your follower count grow!`}
          messageType='profile'
        />
      ) : (
        <EmptyMessage
          title='No Followed Profiles'
          description={`Follow profiles to\n personalise your feed`}
          messageType='profile'
        />
      )
    }

    return currentList === 'followers' ? (
      <EmptyMessage
        title='No Followers Yet'
        description={'This profile does not have\n any followers yet'}
        messageType='profile'
      />
    ) : (
      <EmptyMessage
        title='No Followed Profiles'
        description={`This profile doesn't follow\n anyone yet`}
        messageType='profile'
      />
    )
  }

  return (
    <ProfilesList
      data={data}
      isLoading={!data || isLoading}
      LoadMoreButton={LoadMoreButton}
      location='follow-list'
    />
  )
}
